<div class="dashboard" [testId]="'dashboard-container'">
  <nz-spin *ngIf="loading" nzSize="large" [testId]="'dashboard-loading'" />
  <div class="dashboard-content" *ngIf="!loading" [testId]="'dashboard-content'">
    <div *ngIf="hasError" class="dashboard-error" [testId]="'dashboard-error'">
      <div class="dashboard-error__copy">
        <div class="dashboard-error__title">{{ 'common.load-failed' | i18n }}</div>
        <div class="dashboard-error__desc">{{ 'dashboard.load-failed' | i18n }}</div>
      </div>
      <button
        nz-button
        nzType="default"
        type="button"
        class="dashboard-error__action"
        (click)="reloadDashboard()"
        [testId]="'dashboard-retry-button'"
      >
        {{ 'dashboard.retry' | i18n }}
      </button>
    </div>

    <div nz-row nzGutter="20" class="card-container" [testId]="'dashboard-card-container'">
      <div
        *ngFor="let card of metricCards"
        nz-col
        nzXs="24"
        nzSm="12"
        nzMd="12"
        nzLg="8"
        nzXl="6"
        [testId]="'dashboard-col-' + card.testIdSuffix"
      >
        <nz-card class="card" [testId]="'dashboard-card-' + card.testIdSuffix">
          <div class="card-icon-shell">
            <nz-icon [nzType]="card.icon" class="card-icon" [ngClass]="card.iconClass" [testId]="'dashboard-icon-' + card.testIdSuffix" />
          </div>
          <div class="card-title" [testId]="'dashboard-title-' + card.testIdSuffix">{{ card.titleKey | i18n }}</div>
          <div class="card-value" [testId]="'dashboard-value-' + card.testIdSuffix">{{ getStatisticValue(card.key) | number }}</div>
        </nz-card>
      </div>
    </div>
  </div>
</div>
